/** FRED API compliance constants — https://fred.stlouisfed.org/docs/api/terms_of_use.html */

/** Exact notice required by FRED API Terms of Use (do not paraphrase). */
export const FRED_REQUIRED_NOTICE =
  'This product uses the FRED® API but is not endorsed or certified by the Federal Reserve Bank of St. Louis.';

export const FRED_API_TERMS_URL = 'https://fred.stlouisfed.org/docs/api/terms_of_use.html';
export const FRED_WEB_URL = 'https://fred.stlouisfed.org/';
export const FRED_LEGAL_URL = 'https://fred.stlouisfed.org/legal/';
export const ST_LOUIS_FED_LEGAL_URL = 'https://www.stlouisfed.org/about-us/legal-information';
export const ST_LOUIS_FED_PRIVACY_URL = 'https://www.stlouisfed.org/about-us/privacy-notice';

/** BLS import price indexes for precious metals (via FRED). Gems use community prices, not FRED. */
export const FRED_METAL_SERIES = [
  { label: 'Gold (XAU)', priceKey: 'XAU', seriesId: 'IP7108', unit: 'troy_oz', materials: ['gold'] },
  { label: 'Silver (XAG)', priceKey: 'XAG', seriesId: 'IP7106', unit: 'troy_oz', materials: ['silver'] },
  { label: 'Platinum (XPT)', priceKey: 'XPT', seriesId: 'IP7110', unit: 'troy_oz', materials: ['platinum'] },
  { label: 'Palladium (XPD)', priceKey: 'XPD', seriesId: 'IR14280', unit: 'troy_oz', materials: ['palladium'] },
] as const;

/** @deprecated use FRED_METAL_SERIES */
export const FRED_REFERENCE_SERIES = FRED_METAL_SERIES;
